import { createSlice } from '@reduxjs/toolkit';
import cuid from 'cuid';
import { sanitizeSerializable } from './../../../helpers/sanitize';
const initialState = {};
export const bucketSlice = createSlice({
    name: 'bucket',
    initialState,
    reducers: {
        enqueueBucketPackage: (state, action) => {
            const bucket = state[action.payload.bucket]
                ? state[action.payload.bucket]
                : [];
            bucket.push({
                key: cuid(),
                payload: sanitizeSerializable(action.payload.payload),
            });
            state[action.payload.bucket] = bucket;
        },
        clearBucketPackages: (state) => {
            state = {};
        },
        removeBucketPackage: (state, action) => {
            const { bucket, key } = action.payload;
            state[bucket] = state[bucket].filter((bucketPackage) => bucketPackage.key !== key);
        },
    },
});
export const { enqueueBucketPackage, clearBucketPackages, removeBucketPackage, } = bucketSlice.actions;
export default bucketSlice.reducer;
